import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { appleProfilesReducer } from './apple-profiles.reducer';
import { AppleProfilesEffects } from './apple-profiles.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('apple-profiles', appleProfilesReducer),
    EffectsModule.forFeature([AppleProfilesEffects]),
  ],
  providers: [],
})
export class AppleProfilesStoreModule {}
